import { createSlice } from '@reduxjs/toolkit'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import { getFinancialFBRequest } from './financialTermsApi'
import { FinancialTermsAction, IFinancialTermsState } from './types'

const initialState: IFinancialTermsState = {
  financialTermsFB: {
    cashback_partner: null,
    cashback_standard: null,
    commission_partner: 0,
    commission_standard: 0,
    min_first_refill_partner: 0,
    loading: false,
  },
}

export const fetchFinanceFBThunk = createAsyncThunk(
  FinancialTermsAction.FETCH_FINANCIAL_TERMS_FB,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getFinancialFBRequest()
      return response
    } catch (error: unknown) {
      const axiosError = error as AxiosError
      return rejectWithValue(axiosError.response?.data || axiosError.message)
    }
  }
)

const financialTermsSlice = createSlice({
  name: FinancialTermsAction.SLICE_NAME,
  initialState,
  reducers: {
    setFinancialTermsFBLoading(state) {
      state.financialTermsFB.loading = true
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFinanceFBThunk.pending, (state) => {
        state.financialTermsFB.loading = true
      })
      .addCase(fetchFinanceFBThunk.fulfilled, (state, action) => {
        const data = action.payload
        state.financialTermsFB = {
          ...data,
          loading: false,
        }
      })
      .addCase(fetchFinanceFBThunk.rejected, (state) => {
        state.financialTermsFB.loading = false
      })
  },
})

export const { setFinancialTermsFBLoading } = financialTermsSlice.actions
export const financialTermsReducer = financialTermsSlice.reducer
